module.exports = __webpack_public_path__ + "static/img/zhou.435d9b02.png";